import { createBaseModule, getDefaultInterceptor, createBaseActivityService } from '@golden/gdk-base';
import { extendObj } from '@golden/utils';
import { createCampaignService } from './service/CampaignService';
export function createCampaignModule(baseURL, timeout, lang, customInterceptor = getDefaultInterceptor) {
    const baseModule = createBaseModule(baseURL, timeout, lang, customInterceptor);
    return extendObj(baseModule, {
        activity: createBaseActivityService(baseModule.api, false),
        campaign: createCampaignService(baseModule.api)
    });
}
//# sourceMappingURL=CampaignModule.js.map